<template>
  <div class="login-container">
    <v-form v-model="isValid" class="login-content">
      <span class="main-title">Login</span>

      <v-text-field
        label="Email"
        placeholder="Enter your email address"
        :rules=" [
          v => !!v || 'Email is required',
          v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ]"
        v-model="user_email"
      />

      <v-text-field
        label="Password"
        placeholder="Enter your password"
        type="password"
        :rules="[v => !!v || 'Password is required']"
        v-model="user_password"
      />
      <v-btn rounded
             class="ma-auto"
             color="#def7ff"
             @click="logUser"
             :disabled="!isValid"
      >Login
      </v-btn>
      <span>
        Or
        <span class="signup-link"
              @click="$router.push('/signup')"
        >
          Sign up
        </span>
      </span>
    </v-form>
    <info-snackbar ref="snackbar" :type='"error"' :message="snackbar_message"/>
  </div>
</template>

<script>
import Api from "@/services/api";
import InfoSnackbar from "@/components/InfoSnackbar";

export default {
  name: "login",
  components: {InfoSnackbar},
  data: () => ({
    api: "",
    user_email:"",
    user_password:"",
    snackbar_message:"",
    isValid: true
  }),

  methods: {
    async logUser() {
      const response = await this.api.login(this.user_email, this.user_password);
      if (response !== "") {
        this.$cookies.set('user_token', response.token);
        await this.$emit('login')
      } else {
        this.snackbar_message = "Email and password doesn't match"
        this.$refs['snackbar'].openSnackbar()
      }

    },
  },

  async created() {
    this.api = new Api;

  }
}
</script>

<style scoped>
.main-title {
  text-align: center;
  font-size: 4vh;
  padding-bottom: 2vh;
  font-style: italic;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.login-content {
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;
  padding: 3vh;
  margin: 2vh;
  width: max(50vh, 60vw);
  border-radius: 15px;
}

.signup-link {
  color: blue;
}

.signup-link:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
